<div class="application-alert">Application alerts</div>
<div class="application-alert-container">
  <div
    class="alert-container"
    [ngClass]="{ checkedClass: !showAppAddList, unCheckedClass: showAppAddList }"
  >
    <div class="all-application">
      <div class="radio-button">
        <mat-radio-button
          name="application"
          color="primary"
          value="application"
          [checked]="defaultAppChecked"
          (change)="changeApplication($event)"
          >All Application</mat-radio-button
        >
      </div>
    </div>
    <div class="minimum-severity">
      <div class="minimum-severity-text">Minimum severity</div>
      <div class="apllication-text">
        <mat-select
          class="text custom-select"
          name="appMinimumSeverity"
          [value]="appMinimumSeverity"
          [disabled]="showAppAddList"
          (selectionChange)="minimumSeverityChange($event, 'allApp')"
          [ngClass]="{ 'disable-custom-select': showAppAddList }"
        >
          <mat-option *ngFor="let option of minimumSeverity" [value]="option">
            {{ option }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</div>
<div
  class="custom-application-container"
  [ngClass]="{ checkedClass: showAppAddList, unCheckedClass: !showAppAddList }"
>
  <div class="custom-application-configuration">
    <div class="custum-radio">
      <mat-radio-button
        name="application"
        color="primary"
        value="custom-application"
        [checked]="!defaultAppChecked"
        (change)="changeApplication($event)"
      ></mat-radio-button>
    </div>
    <div class="configuration-text">
      <div class="configuration-text">Custom application configuration</div>
      <div class="sub-text">Receive emails for these application only</div>
    </div>
  </div>
  <div class="table-container" *ngIf="showAppAddList">
    <mat-table [dataSource]="userDefinedAppData" *ngIf="userDefinedAppData.data.length">
      <ng-container matColumnDef="application">
        <th mat-header-cell *matHeaderCellDef>Application</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="minimumseverity">
        <th mat-header-cell *matHeaderCellDef>Minimum severity</th>
        <td mat-cell *matCellDef="let element">
          <mat-select
            class="text custom-select"
            name="customAppMinimumSeverity"
            [value]="element.minimumSeverity"
            (selectionChange)="minimumSeverityChange($event, 'customAppSeverity', element)"
          >
            <mat-option *ngFor="let option of minimumSeverity" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </td>
      </ng-container>

      <ng-container matColumnDef="remove">
        <th mat-header-cell *matHeaderCellDef>Remove</th>
        <td mat-cell *matCellDef="let row">
          <mat-icon class="remove-icon" (click)="removeApp(row)">clear</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="appsdisplayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: appsdisplayedColumns"></tr>
    </mat-table>
    <div class="add-list">
      <mat-icon class="add-icon" (click)="openAppSelectionWizard('user_app_selection')"
        >add_box</mat-icon
      >
      <span>Add application alert</span>
    </div>
  </div>
  <nrwl-paginator
    #paginator
    [totalResult]="userDefinedAppData.data.length"
    (nextPage)="nextPage($event)"
  ></nrwl-paginator>
</div>
